export default __webpack_public_path__ + "static/media/happyearthsolutions-project.9d4bad3e.webp";